// A load error that knows about the session: signed out, it is the sign-in
// prompt; signed in with a session error (a 401), it offers to sign in again;
// anything else is the shared ErrorState with a retry.
import {
  AuthIssueScreen,
  ErrorState,
  SignInScreen,
  isAuthError,
} from "@jkast90/kast-common/ui";
import { signInScreen } from "../signInScreen";

interface Props {
  error: unknown;
  isLoggedIn: boolean;
  onLogin?: () => void;
  onLogout?: () => void;
  onRetry?: () => void;
}

export default function ErrorMessage({
  error,
  isLoggedIn,
  onLogin,
  onLogout,
  onRetry,
}: Props) {
  if (!isLoggedIn)
    return (
      <SignInScreen
        {...signInScreen()}
        onSignIn={onLogin ?? signInScreen().onSignIn}
      />
    );

  if (isAuthError(error)) {
    return (
      <AuthIssueScreen
        title="Your session needs renewing"
        detail="Sign out and back in to carry on."
        onSignOut={onLogout}
      />
    );
  }

  return <ErrorState error={error} onRetry={onRetry} />;
}
